import React from "react";
import module from "./UnsubscribeComplete.module.css";
import MostBottomButton from "../components/atomic/molecular/MostBottomButton";
import { useNavigate } from "react-router-dom";

const UnsubscribeComplete = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div>
      <div className={module.img}>
        <img src={process.env.PUBLIC_URL + "/svg/reward.svg"} alt="reward" />
      </div>
      <div className={module.sub}>
        <p>退会手続きが完了しました。</p>
        <p>今後ともナッシュをよろしくお願いいたします。</p>
      </div>
      <MostBottomButton label={"HOMEに戻る"} handleClick={handleClick} />
    </div>
  );
};

export default UnsubscribeComplete;
